import dayjs from 'dayjs';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useProps, useStore } from '../../utils/mobx.utils';
import BodyCopyRenderer from '../BodyCopyRenderer/BodyCopyRenderer';
import EmotionIcon from '../EmotionIcon/EmotionIcon';
import UsernameRenderer from '../UsernameRenderer/UsernameRenderer';
import './ThoughtCard.scss';
var ThoughtCard = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get length() {
            var _a;
            return ((_a = p.thought.content) === null || _a === void 0 ? void 0 : _a.length) || 0;
        },
        get lengthName() {
            return s.length > 120 ? 'long' : s.length < 20 ? 'short' : 'medium';
        },
    }); });
    var createRecentTimeCreated = function (thoughtId, timeCreated) {
        switch (thoughtId) {
            case 1001:
                // few hours ago.
                // return dayjs().subtract(getRandomInteger(1,12), 'hour').format()
                return dayjs().subtract(6, 'hour').format();
            case 1002:
                // few hours ago.
                // return dayjs().subtract(getRandomInteger(13,23), 'hour').format()
                return dayjs().subtract(11, 'hour').format();
            case 1003:
                // few days ago.
                // return dayjs().subtract(getRandomInteger(1,2), 'day').format()
                return dayjs().subtract(1, 'day').format();
            case 1004:
                // few days ago.
                // return dayjs().subtract(getRandomInteger(3,4), 'day').format()
                return dayjs().subtract(2, 'day').format();
            case 1005:
                // few days ago.
                // return dayjs().subtract(getRandomInteger(5,7), 'day').format()
                return dayjs().subtract(4, 'day').format();
            default:
                return timeCreated;
        }
    };
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "ThoughtCard", "data-id": p.thought.id, "data-emotion": p.thought.emotionId, "data-length": s.lengthName },
            React.createElement("div", { className: "ThoughtCardInner" },
                React.createElement("header", { className: "ThoughtCardHeader" },
                    p.thought.emotionId && React.createElement(EmotionIcon, { emotion: p.thought.emotionId, size: 28 }),
                    React.createElement("strong", null,
                        React.createElement(UsernameRenderer, { user: p.thought.user, showColorLabel: true }),
                        "\u00A0\u2022"),
                    p.thought.timeCreated && React.createElement("span", null, dayjs.utc(createRecentTimeCreated(parseInt(p.thought.id), p.thought.timeCreated)).local().fromNow())),
                React.createElement("div", { className: "ThoughtCardContent" },
                    React.createElement("div", { className: "ThoughtCardContentBody" },
                        React.createElement(BodyCopyRenderer, { source: p.thought.content })),
                    (p.thought.situation || p.thought.response) && React.createElement("div", { className: "ThoughtCardContentSecondary" },
                        p.thought.situation && React.createElement("div", { className: "ThoughtCardContentSituation" },
                            React.createElement("h3", null, "Situation"),
                            React.createElement(BodyCopyRenderer, { source: p.thought.situation })),
                        p.thought.response && React.createElement("div", { className: "ThoughtCardContentResponse" },
                            React.createElement("h3", null, "Response"),
                            React.createElement(BodyCopyRenderer, { source: p.thought.response }))))))); } });
};
export default ThoughtCard;
